import * as Yup from 'yup';
import {
  NUMBER_TYPE_ERROR_MSG,
  FUEL_LEFT_IN_TANK_ERROR_MSG,
  REQUESTED_QUANTITY_ERROR_MSG
} from 'src/utils/constants';
import { getMaxLimitErrorMsg } from 'src/utils/getInitials';

// card approvals form model
export const cardApprovalsFormModel = {
  formId: 'cardApprovalsConfig',
  formField: {
    vehicleNumber: {
      name: 'vehicle_number',
      label: 'Vehicle Number',
      requiredErrorMsg: 'Vehicle number is required',
      type: 'text'
    },
    cardName: {
      name: 'card_id',
      label: 'Select Card',
      requiredErrorMsg: 'Card selection is required',
      type: 'select'
    },
    tankCapacity: {
      name: 'tank_capacity',
      label: 'Vehicle Tank Capacity',
      requiredErrorMsg: 'Vehicle Tank Capacity is required',
      type: 'text'
    },
    tankFuelPercentage: {
      name: 'tank_fuel_percentage',
      label: 'Fuel left in Tank',
      requiredErrorMsg: 'Fuel left percentage is required',
      type: 'text'
    },
    requestedQuantity: {
      name: 'requested_quantity',
      label: 'Request Limit',
      requiredErrorMsg: 'Request Limit is required',
      invalidErrorMsg: 'Invalid Request Limit',
      type: 'text'
    },
    odometerEntry: {
      name: 'odometer_entry',
      label: 'Odometer Reading',
      type: 'text'
    }
  }
};

// Initial values
const {
  formField: {
    vehicleNumber,
    cardName,
    tankCapacity,
    tankFuelPercentage,
    requestedQuantity,
    odometerEntry
  }
} = cardApprovalsFormModel;

export const cardApprovalFormInitialValues = {
  [vehicleNumber.name]: '',
  [cardName.name]: '',
  [tankCapacity.name]: '',
  [tankFuelPercentage.name]: '',
  [requestedQuantity.name]: '',
  [odometerEntry.name]: '',
};

// validation schema
export const cardApprovalsValidationSchema = Yup.object().shape({
  [vehicleNumber.name]: Yup.string().trim().required(vehicleNumber.requiredErrorMsg),
  [cardName.name]: Yup.string().required(cardName.requiredErrorMsg),
  [tankFuelPercentage.name]: Yup.number().min(0, FUEL_LEFT_IN_TANK_ERROR_MSG).max(100, getMaxLimitErrorMsg(tankFuelPercentage, '100%')).required(tankFuelPercentage.requiredErrorMsg)
    .typeError(NUMBER_TYPE_ERROR_MSG),
  [requestedQuantity.name]: Yup.number().min(0, REQUESTED_QUANTITY_ERROR_MSG).required(requestedQuantity.requiredErrorMsg)
    .typeError(NUMBER_TYPE_ERROR_MSG)
    .when(tankFuelPercentage.name, (tankLevel, schema, config) => {
      if (config.parent?.requested_quantity && config.parent?.tank_capacity && tankLevel <= 100) {
        const getOnePercentValue = config.parent.tank_capacity / 100;
        const maxLimitAllowed = (getOnePercentValue * (100 - tankLevel)).toFixed(2);
        if (config.parent.requested_quantity > maxLimitAllowed) {
          return schema.max(maxLimitAllowed, getMaxLimitErrorMsg(requestedQuantity, maxLimitAllowed));
        }
      }
      return schema;
    }),
  [odometerEntry.name]: Yup.number().nullable().transform((value, originalValue) => (originalValue === '' ? null : value))
    .typeError(NUMBER_TYPE_ERROR_MSG)
    .max(999999, getMaxLimitErrorMsg(odometerEntry, 999999)),
});
